module.exports = "<div id=\"js-overlay\" class=\"overlay\">\n    <div class=\"overlay__inner\">\n        <div class=\"wrapper\">\n            <div id=\"overlayClose\" class=\"ovrlay-close\">\n                <span class=\"line line1\"></span>\n                <span class=\"line line2\"></span>\n            </div>\n            <div id=\"js-overlayContent\" class=\"overlay-content\"></div>\n        </div>\n    </div>\n    <div id=\"js-overlayLoading\" class=\"overlay-loading\"></div>\n</div><!--overlay-->\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pc/assets/js/template/overlay.html
 ** module id = 23
 ** module chunks = 0
 **/